module.exports = __webpack_public_path__ + "static/media/men's-grooming.bc24269f.webp";